import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux-immutable';
import { List, fromJS } from 'immutable';
import { setSearchText, setSearchLoading, setSearchEntries } from "./actions.js";
import paginationReducer from "../utils/paginationReducer.js";
var searchText = handleActions(_defineProperty({}, setSearchText, function (state, action) {
  return action.payload;
}), '');
var isLoading = handleActions(_defineProperty({}, setSearchLoading, function (state, action) {
  return action.payload;
}), true);
var entries = handleActions(_defineProperty({}, setSearchEntries, function (state, action) {
  return fromJS(action.payload);
}), List());
export default combineReducers({
  searchText: searchText,
  isLoading: isLoading,
  entries: entries,
  pagination: paginationReducer('SEARCH')
});